export const DEFAULT_SORT_ATTRIBUTE = "Relevance";

export enum SortOrderEnum {
  Desc = "DESC",
  Asc = "ASC",
}

export const i18n = {
  sort: "Sort:",
};
